import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { AuthService } from '../auth.service';
import { Usuario } from '../../../models/usuario';
import { Perfis } from '../../../models/perfis';

@Component({
  templateUrl: './admin.component.html'
})
export class AdminComponent extends WebPage implements OnInit {

  usuario: Usuario;

  constructor(private authService: AuthService, messageService: MessageService) {
    super(messageService);
  }

  ngOnInit() {
    this.usuario = this.authService.informacoesUsuario();
  }

  podeTrocarPerfil() {
    return this.usuario.Perfil === Perfis.AdministradorSistema;
  }

  podeVerGerenciaDeEditalCredenciamento() {
    return this.usuario.Perfil === Perfis.AdministradorSistema
      || this.usuario.Perfil === Perfis.GestorDex
      || this.usuario.Perfil === Perfis.AdministrativoDex;
  }

  podeVerInscricaoCadastroCnpj() {
    return this.usuario.Perfil === Perfis.AdministradorSistema
      || this.usuario.Perfil === Perfis.GestorDex
      || this.usuario.Perfil === Perfis.AdministrativoDex;
  }

  podeVerGerenciaDeFases() {
    return this.usuario.Perfil === Perfis.AdministradorSistema
      || this.usuario.Perfil === Perfis.GestorDex
      || this.usuario.Perfil === Perfis.AdministrativoDex;
  }

  podeVerConvocarAluno() {
    return this.usuario.Perfil === Perfis.AdministradorSistema
      || this.usuario.Perfil === Perfis.GestorUnidadeOperacional
      || this.usuario.Perfil === Perfis.AdministrativoUnidadeOperacional;
  }

  podeVerInformacoesComplementares() {
    return this.usuario.Perfil === Perfis.AdministradorSistema
    || this.usuario.Perfil === Perfis.GestorDex
    || this.usuario.Perfil === Perfis.AdministrativoDex;
  }

  podeVerFinanceiro() {
    return this.usuario.Perfil === Perfis.AdministradorSistema
    || this.usuario.Perfil === Perfis.GestorDex
    || this.usuario.Perfil === Perfis.AdministrativoDex;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/admin/admin.component.ts